import { Swiper } from 'swiper';
import { Autoplay } from 'swiper/modules';

const sliders = document.querySelectorAll('.block-logo-carousel .swiper');

if (sliders.length > 0) {
	const intialUrl = new URL(window.location);
	const backstop = intialUrl.searchParams.get('backstop');

	sliders.forEach((slider) => {
		const settings = {
			loop: true,
			spaceBetween: 16,
			slidesPerView: 2.4375,
			modules: [Autoplay],
			speed: 2000,
			autoplay: {
				delay: 0,
			},
			breakpoints: {
				448: {
					slidesPerView: 3,
				},
				576: {
					slidesPerView: 4,
					spaceBetween: 24,
				},
				768: {
					slidesPerView: 5,
					spaceBetween: 32,
				},
				992: {
					slidesPerView: 6,
					spaceBetween: 32,
				},
			},
		};

		// Loop mode needs more slides than the largest slidesPerView so Swiper
		// can build its duplicate buffers. With too few logos, loop is disabled
		// and the marquee never animates. Clone the original slides until there
		// are comfortably enough for loop mode.
		const wrapper = slider.querySelector('.swiper-wrapper');

		if (wrapper) {
			const maxSlidesPerView = Math.ceil(
				Object.values(settings.breakpoints).reduce(
					(max, bp) => Math.max(max, bp.slidesPerView || 0),
					settings.slidesPerView
				)
			);
			const minSlides = maxSlidesPerView * 2;
			const originals = Array.from(
				wrapper.querySelectorAll('.swiper-slide')
			);

			if (originals.length > 0 && originals.length < minSlides) {
				while (
					wrapper.querySelectorAll('.swiper-slide').length < minSlides
				) {
					originals.forEach((slide) => {
						const clone = slide.cloneNode(true);
						clone.setAttribute('aria-hidden', 'true');
						wrapper.appendChild(clone);
					});
				}
			}
		}

		if (backstop) {
			settings.autoplay = false;
		}

		const swiperInstance = new Swiper(slider, settings);

		const sliderParent = slider.closest('.block-logo-carousel');

		sliderParent.addEventListener('mouseenter', () => {
			swiperInstance.autoplay.stop();
		});

		sliderParent.addEventListener('mouseleave', () => {
			swiperInstance.autoplay.start();
		});
	});
}
